// v1.4.1 Phase 20 cache-bust redeploy 2026-05-22 — the first Phase 20
// deploy attempt failed mid-upload during a Cloudflare API outage; the
// re-run trusted partial-upload cache (`11 already uploaded`) and shipped
// a corrupt bundle that returned HTTP 500 from the edge. Touch this file
// to force Vite to compute fresh content-hashed asset names, defeating
// wrangler's hash-based "already uploaded" skip and forcing a clean
// fresh upload of every chunk.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

// v1.4.1 Phase 20 cache-bust marker (2026-05-22). The original Phase 20
// commit hashed to `index-B1T94z9e.js`; that asset shipped corrupt during
// a Cloudflare API outage and the redeploy trusted wrangler's hash cache.
// This runtime-observable string forces Vite to recompute the content hash
// so wrangler re-uploads every chunk from scratch. Safe to leave in place;
// it's also a useful build marker for debugging future deploy issues.
const BUILD_VERSION = "hookum-v1.4.1-phase20-2026-05-22T18:25Z";
console.info("[hookum]", BUILD_VERSION);

// v1.4.1 Phase 21.1V: dev-only test seam. Exposes store + socket + actions on
// `globalThis.__hookum` so Playwright specs can drive the closed-connection +
// Rejoin button paths that have no wire-layer trigger (the DisconnectedPanel
// renders only when `code && conn.kind === "closed"`, and the socket layer
// never naturally reaches "closed" with code preserved). Dead-code-eliminated
// in the production build because `import.meta.env.DEV` is statically false.
if (import.meta.env.DEV) {
  void import("./wire/index.js").then((wire) => {
    void import("./state/store.js").then((s) => {
      (globalThis as { __hookum?: unknown }).__hookum = {
        store: s.store,
        socket: wire.socket,
        actions: wire.actions,
      };
    });
  });
}

const host = document.getElementById("root");
if (!host) throw new Error("missing #root");
createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
